const initialState = {
  id: 0,
  name: '',
  surname: '',
  username: '',
  type: 'customer',
  phoneOffice: '',
  phoneMobile: '',
  email: '',
  address: '',
  postalCode: '',
  city: '',
  note: '',
  state: '',
  privacy: false,
  newsletter: false,
  companyId: 0,
  companies: [],
  enabledCompanies: []
};

export default initialState;
